import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/sysFormFireControl/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/sysFormFireControl/saveOrUpdate',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/sysFormFireControl/detail/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/sysFormFireControl/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/sysFormFireControl/' + id,
method: 'put',
data: obj
})
}
